var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19937 9.66319C7.93625 9.54723 7.62945 9.66944 7.51609 9.93307C6.98154 11.1644 5.76629 11.96 4.42 11.96C2.55633 11.96 1.04 10.4437 1.04 8.58003C1.04 7.37154 1.69104 6.24991 2.73833 5.6514C2.98845 5.50944 3.07478 5.19173 2.93229 4.94211C2.79033 4.69252 2.47208 4.60411 2.223 4.74866C0.851754 5.53125 0 6.99921 0 8.58003C0 11.0173 1.98275 13 4.42 13C6.18125 13 7.77088 11.9585 8.46976 10.347C8.58417 10.0839 8.46351 9.77758 8.19937 9.66319Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9227 10.2071C11.8156 9.9398 11.515 9.8098 11.2467 9.91692L10.4688 10.2284L9.33673 6.60504C9.26861 6.38767 9.06736 6.24 8.83961 6.24H5.12577L4.96406 5.2H7.01961C7.30716 5.2 7.53961 4.96755 7.53961 4.68C7.53961 4.39245 7.30716 4.16 7.01961 4.16H4.80286L4.53402 2.42788C4.92922 2.20429 5.19961 1.78567 5.19961 1.3C5.19961 0.582918 4.61669 0 3.89961 0C3.18306 0 2.59961 0.582918 2.59961 1.3C2.59961 1.87563 2.97816 2.35925 3.49765 2.52979L4.16586 6.83955C4.20539 7.0933 4.42327 7.28 4.67961 7.28H8.4574L9.64299 11.075C9.68667 11.2133 9.78549 11.3272 9.91653 11.3895C9.98673 11.4233 10.0637 11.44 10.1396 11.44C10.2051 11.44 10.2706 11.428 10.3331 11.4031L11.6331 10.8831C11.8998 10.7765 12.0293 10.4738 11.9227 10.2071Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisability);
export default __webpack_public_path__ + "static/media/Disability.9e539a777d8da973779c383da4af5bec.svg";
export { ForwardRef as ReactComponent };